import styled from "styled-components";
import { Link } from "react-router-dom";
import { MenuOutlined } from "@ant-design/icons";

export const HeaderSection = styled("header")`
  padding: 0.5rem 0.5rem;
  position: fixed;
  width: 100%;
  z-index: 100;
  backdrop-filter: blur(1.5px);
  background-color: transparent;
  overflow-x: hidden;

  .ant-row-space-between {
    align-items: center;
    text-align: center;
  }
`;

export const LogoContainer = styled(Link)`
  display: flex;
  
  img {
    height: 100px;
    max-width: 100%;
    object-fit: contain;
    
    @media only screen and (max-width: 768px) {
      height: 70px;
    }
    
    @media only screen and (max-width: 414px) {
      height: 60px;
    }
  }
`;

export const NavLink = styled("div")`
  display: inline-block;
  text-align: center;
`;

export const CustomNavLink = styled("div")`
  width: 203px;
  display: inline-block;

  @media only screen and (max-width: 411px) {
    width: 150px;
  }

  @media only screen and (max-width: 320px) {
    width: 118px;
  }
`;

export const Burger = styled("div")`
  @media only screen and (max-width: 1024px) {
    display: block;
  }

  display: none;
  flex-shrink: 0; /* Prevent icon from being compressed */

  svg {
    fill: #2e186a;
  }
`;

export const NotHidden = styled("div")`
  @media only screen and (max-width: 1024px) {
    display: none;
  }
`;

export const Menu = styled("h5")`
  font-size: 1.5rem;
  font-weight: 600;
  text-align: center;
`;

export const CustomNavLinkSmall = styled(NavLink)`
  font-size: 1.2rem;
  color: #18216d;
  transition: color 0.2s ease-in;
  margin: 0.5rem 2rem;

  @media only screen and (max-width: 768px) {
    margin: 1.25rem 2rem;
  }
`;

export const Label = styled("span")`
  font-weight: 500;
  color: #404041;
  text-align: right;
  display: flex;
  justify-content: space-between;
  align-items: baseline;
`;

export const Outline = styled(MenuOutlined)`
  font-size: 22px;
`;

export const Span = styled("span")`
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  color: #000000;

  &:hover,
  &:active,
  &:focus {
    color: #ff0000;
    text-underline-position: under;
    text-decoration: #ff0000 wavy underline;
  }
`;

export const LogoText = styled("span")`
  font-weight: bold;
  font-size: 1.5rem;
`;
